import React, { useState, useEffect } from "react";
import { FaAngleUp } from "react-icons/fa";

const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Show button when the page is scrolled down
  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    // Smooth scroll to the top with a smooth transition effect
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Smooth scrolling behavior
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  return (
    <button
      type="button"
      title="Go to top"
      aria-label="Scroll to top"
      onClick={scrollToTop}
      className={`fixed bottom-4 right-4 bg-transparent border-2 border-[#0860C7] text-[#0860C7] font-bold rounded-full flex justify-center items-center transition duration-300 ease-in-out transform hover:bg-[#9629E7] hover:text-white hover:scale-105 shadow-lg ${
        isVisible ? "opacity-100" : "opacity-0"
      }`}
      style={{
        width: "48px",
        height: "48px",
        zIndex: 1000,
      }}
    >
      <FaAngleUp size={24} />
    </button>
  );
};

export default ScrollToTopButton;
